import config from "../../../config";
import {
  generate,
  getCurrentCustomerId,
  getCurrentSiteId,
  ROUTE_SITE_DASHBOARD,
  getCurrentWorkflowId,
  generateDashboardRoute,
} from "../../../redux/modules/route/routes";
import { pushRoute } from "../../../redux/modules/route/actions";
// @ts-ignore
import { ensureCurrentSite } from "../../../redux/modules/currentSite/asyncActions";
import { AppDispatch, AppGetState } from "../../../store";
import { getRouterState } from "../../../redux/modules/rootReducer";

import { fetchSiteLevelWorkflow } from "../../../redux/modules/workflow/actions";
import { performWorkflowActions } from "../../../redux/modules/workflow/actions";
import { getWorkflowStateById } from "../../../redux/modules/workflow/reducer";
import {
  IWorkflowAction,
  IWorkflowStep,
} from "../../../redux/modules/currentWorkflow/reducer";
import { ensureAcl } from "../../../acl/asyncActions";
import { siteContextRequest } from "../../../redux/siteContextRequest";

export const userClicksDeleteWorkflowButton = (
  workflowType: string,
  workflowId: string,
) => async (dispatch: AppDispatch, getState: AppGetState): Promise<void> => {
  const route = getState().route;
  const customerId = getCurrentCustomerId(route);
  const siteId = getCurrentSiteId(route);
  if (!customerId || !siteId) {
    throw new Error("Error, cant get customerId or siteId from route");
  }

  const iAmSure = confirm(
    [
      "Are you sure you want to delete this workflow?",
      "This will not delete data from S3 and publications in Office App.",
    ].join(" \n"),
  );
  if (!iAmSure) {
    return;
  }

  const url = `${
    config.endpoints.backofficeWebService
  }/api/customer/${customerId}/site/${siteId}/workflow/${workflowType.toLowerCase()}/delete/${workflowId}`;
  try {
    await dispatch(
      siteContextRequest(customerId, siteId, {
        method: "POST",
        url,
      }),
    );
  } catch (e) {
    alert("Error, failed to delete workflow");
    return;
  }

  dispatch(
    pushRoute(
      generate(ROUTE_SITE_DASHBOARD, {
        customerId,
        siteId,
      }),
    ),
  );
};

export const userOpensWorkflowViewPage = () => async (
  dispatch: AppDispatch,
  getState: AppGetState,
): Promise<void> => {
  const customerId = getCurrentCustomerId(getState().route);
  const siteId = getCurrentSiteId(getState().route);
  if (!siteId) {
    throw new Error(
      "Unexpected runtime error: site id is not defined on site workflow page",
    );
  }
  await dispatch(ensureAcl(customerId, siteId));
  await dispatch(ensureCurrentSite(customerId, siteId));
  await dispatch(userOpensWorkflowViewPageOldStyle());
};

export const userOpensWorkflowViewPageOldStyle = () => async (
  dispatch: AppDispatch,
  getState: AppGetState,
): Promise<void> => {
  const routeState = getRouterState(getState());
  const siteId = getCurrentSiteId(routeState);
  if (!siteId) {
    throw new Error(
      "Unexpected runtime error: site id is not defined on site workflow page",
    );
  }
  const customerId = getCurrentCustomerId(routeState);
  const workflowId = getCurrentWorkflowId(routeState);
  await dispatch(fetchSiteLevelWorkflow(customerId, siteId, workflowId));
};

export const userSubmitsWorkflowStep = (
  step: IWorkflowStep,
  actions: IWorkflowAction[],
) => async (dispatch: AppDispatch, getState: AppGetState): Promise<void> => {
  const routeState = getRouterState(getState());
  const currentCustomerId = getCurrentCustomerId(routeState);
  const currentWorkflowId = getCurrentWorkflowId(routeState);
  const currentSiteId = getCurrentSiteId(routeState);
  // @ts-ignore
  const workflowsState = getState().workflows;
  const workflowState = getWorkflowStateById(workflowsState, currentWorkflowId)
    .entry;
  await dispatch(
    performWorkflowActions(
      workflowState.id,
      workflowState.workflowType,
      step,
      actions,
      currentCustomerId,
      currentSiteId,
    ),
  );
};

export const userClicksBackButton = () => async (
  dispatch: AppDispatch,
  getState: AppGetState,
): Promise<void> => {
  const route = getRouterState(getState());
  const customerId: string = getCurrentCustomerId(route);
  const siteId = getCurrentSiteId(route);
  if (!siteId) {
    throw new Error(
      "Unexpected runtime error: site id is not defined on site workflow page",
    );
  }
  dispatch(pushRoute(generateDashboardRoute(customerId, siteId)));
};
